// Datos de ejemplo para poblar la tabla
export const dataRegistros = [
  {
    nombre: "Titular del perfil de facebook \"POLIMEMES DEL SUR\".",
    sexo: "N/A",
    ambito: "Estatal",
    entidad: "Tlaxcala",
    municipio: "XICOHTZINCO, TLAXCALA",
    relacion: "N/A",
    incidencia: "N/A",
    expediente: "TET-PES-071/2024",
    organo: "Tribunal Electoral de Tlaxcala",
    fecha: "21 de Julio de 2025",
    conducta: "Violencia política contra las mujeres en razón de genero",
    sancion: "Inscripción en el Registro Nacional de Personas Sancionadas en Materia de Violencia Política contra las mujeres en razón de genero del INE y el Registro Estatal de Personas Sancionadas en materia de Violencia Política Contra las Mujeres en Razón de Género del ITE",
    permanencia: "2 años",
    analizo: "N/A",
    cumple: "N/A",
    calidad: "Titular y/o administrador de perfil de Facebook",
    documento: "https://sistemas-tet.org.mx/estrados/archivos/20250730210432_ACUERDO-PES-071-2024.pdf",
  },
  {
    nombre: "Titular del perfil de facebook \"SANTOCHO LIBRE EXPRESIÓN\".",
    sexo: "Hombre",
    ambito: "Estatal",
    entidad: "Tlaxcala",
    municipio: "XICOHTZINCO, TLAXCALA",
    relacion: "N/A",
    incidencia: "N/A",
    expediente: "TET-PES-071/2024",
    organo: "Tribunal Electoral de Tlaxcala",
    fecha: "21 de Julio de 2025",
    conducta: "Violencia política contra las mujeres en razón de genero",
    sancion: "Inscripción en el Registro Nacional de Personas Sancionadas en Materia de Violencia Política contra las mujeres en razón de genero del INE y el Registro Estatal de Personas Sancionadas en materia de Violencia Política Contra las Mujeres en Razón de Género del ITE",
    permanencia: "2 años",
    analizo: "N/A",
    cumple: "N/A",
    calidad: "Titular y/o administrador de perfil de Facebook",
    documento: "https://sistemas-tet.org.mx/estrados/archivos/20250730210432_ACUERDO-PES-071-2024.pdf",
  },



  {
    nombre: "Angel Gabriel Guevara Aquino titular del usuario de Facebook \"Angel.AG.2023\"",
    sexo: "Masculino",
    ambito: "Municipal",
    entidad: "Tlaxcala",
    municipio: "Huamantla",
    relacion: "N/A",
    incidencia: "N/A",
    expediente: "TET-PES-002/2025",
    organo: "TET",
    fecha: "01 de Septiembre de 2026",
    conducta: "Las publicaciones denunciadas, actualizan la infracción de VPG, al contener manifestaciones dirigidas a sexualizar y desacreditar a la denunciante con estereotipos de género.",
    sancion: "",
    permanencia: "1 AÑO",
    analizo: "N/A",
    cumple: "N/A",
    calidad: "N/A",
    documento: "https://sistemas-tet.org.mx/sistemas/archivos/resoluciones/20260923195741_RESOLUCION_TET-PES-002-2025.pdf ",
  },

  {
    nombre: "Mariela Gutiérrez titular del usuario de Facebook \"Marielagutierrezhuamantla\"",
    sexo: "N/A",
    ambito: "Municipal",
    entidad: "Tlaxcala",
    municipio: "Huamantla",
    relacion: "N/A",
    incidencia: "N/A",
    expediente: "TET-PES-002/2025",
    organo: "TET",
    fecha: "01 de Septiembre de 2026",
    conducta: "Las publicaciones denunciadas, actualizan la infracción de VPG, al contener manifestaciones dirigidas a sexualizar y desacreditar a la denunciante con estereotipos de género.",
    sancion: "",
    permanencia: "INDETERMINADO",
    analizo: "N/A",
    cumple: "N/A",
    calidad: "N/A",
    documento: "https://sistemas-tet.org.mx/sistemas/archivos/resoluciones/20260923195741_RESOLUCION_TET-PES-002-2025.pdf",
  },

  {
    nombre: "Edel Torres titular del usuario de Facebook \"edel.torres\"",
    sexo: "N/A",
    ambito: "Municipal",
    entidad: "Tlaxcala",
    municipio: "Huamantla",
    relacion: "N/A",
    incidencia: "N/A",
    expediente: "TET-PES-002/2025",
    organo: "TET",
    fecha: "01 de Septiembre de 2026",
    conducta: "Las publicaciones denunciadas, actualizan la infracción de VPG, al contener manifestaciones dirigidas a sexualizar y desacreditar a la denunciante con estereotipos de género.",
    sancion: "",
    permanencia: "INDETERMINADO",
    analizo: "N/A",
    cumple: "N/A",
    calidad: "N/A",
    documento: "https://sistemas-tet.org.mx/sistemas/archivos/resoluciones/20260923195741_RESOLUCION_TET-PES-002-2025.pdf",
  },


  {
    nombre: "Caridad Loaiza titular del usuario de Facebook \"Caridadangelica.loaizabautista\"",
    sexo: "N/A",
    ambito: "Municipal",
    entidad: "Tlaxcala",
    municipio: "Huamantla",
    relacion: "N/A",
    incidencia: "N/A",
    expediente: "TET-PES-002/2025",
    organo: "TET",
    fecha: "01 de Septiembre de 2026",
    conducta: "Las publicaciones denunciadas, actualizan la infracción de VPG, al contener manifestaciones dirigidas a sexualizar y desacreditar a la denunciante con estereotipos de género.",
    sancion: "",
    permanencia: "INDETERMINADO",
    analizo: "N/A",
    cumple: "N/A",
    calidad: "N/A",
    documento: "https://sistemas-tet.org.mx/sistemas/archivos/resoluciones/20260923195741_RESOLUCION_TET-PES-002-2025.pdf",
  },



  {
    nombre: "Peligrosamx / Huamantlatv titular del usuario de Facebook \"Huamantla. TV\"",
    sexo: "N/A",
    ambito: "Municipal",
    entidad: "Tlaxcala",
    municipio: "Huamantla",
    relacion: "N/A",
    incidencia: "N/A",
    expediente: "TET-PES-002/2025",
    organo: "TET",
    fecha: "01 de Septiembre de 2026",
    conducta: "Las publicaciones denunciadas, actualizan la infracción de VPG, al contener manifestaciones dirigidas a sexualizar y desacreditar a la denunciante con estereotipos de género.",
    sancion: "",
    permanencia: "INDETERMINADO",
    analizo: "N/A",
    cumple: "N/A",
    calidad: "N/A",
    documento: "https://sistemas-tet.org.mx/sistemas/archivos/resoluciones/20260923195741_RESOLUCION_TET-PES-002-2025.pdf",
  },
  {
    nombre: "Chema Méndez titular del usuario de Facebook \"Elchemamendez1. TV\"",
    sexo: "N/A",
    ambito: "Municipal",
    entidad: "Tlaxcala",
    municipio: "Huamantla",
    relacion: "N/A",
    incidencia: "N/A",
    expediente: "TET-PES-002/2025",
    organo: "TET",
    fecha: "01 de Septiembre de 2026",
    conducta: "Las publicaciones denunciadas, actualizan la infracción de VPG, al contener manifestaciones dirigidas a sexualizar y desacreditar a la denunciante con estereotipos de género.",
    sancion: "",
    permanencia: "INDETERMINADO",
    analizo: "N/A",
    cumple: "N/A",
    calidad: "N/A",
    documento: "https://sistemas-tet.org.mx/sistemas/archivos/resoluciones/20260923195741_RESOLUCION_TET-PES-002-2025.pdf",
  },
  {
    nombre: "Edgar Conde titular del usuario de Facebook \"edgarr.conde\"",
    sexo: "N/A",
    ambito: "Municipal",
    entidad: "Tlaxcala",
    municipio: "Huamantla",
    relacion: "N/A",
    incidencia: "N/A",
    expediente: "TET-PES-002/2025",
    organo: "TET",
    fecha: "01 de Septiembre de 2026",
    conducta: "Las publicaciones denunciadas, actualizan la infracción de VPG, al contener manifestaciones dirigidas a sexualizar y desacreditar a la denunciante con estereotipos de género.",
    sancion: "",
    permanencia: "INDETERMINADO",
    analizo: "N/A",
    cumple: "N/A",
    calidad: "N/A",
    documento: "https://sistemas-tet.org.mx/sistemas/archivos/resoluciones/20260923195741_RESOLUCION_TET-PES-002-2025.pdf",
  },
  {
    nombre: "Rubí Sánchez titular del usuario de Facebook \"Rubí Sánchez\"",
    sexo: "N/A",
    ambito: "Municipal",
    entidad: "Tlaxcala",
    municipio: "Huamantla",
    relacion: "N/A",
    incidencia: "N/A",
    expediente: "TET-PES-002/2025",
    organo: "TET",
    fecha: "01 de Septiembre de 2026",
    conducta: "Las publicaciones denunciadas, actualizan la infracción de VPG, al contener manifestaciones dirigidas a sexualizar y desacreditar a la denunciante con estereotipos de género.",
    sancion: "",
    permanencia: "INDETERMINADO",
    analizo: "N/A",
    cumple: "N/A",
    calidad: "N/A",
    documento: "https://sistemas-tet.org.mx/sistemas/archivos/resoluciones/20260923195741_RESOLUCION_TET-PES-002-2025.pdf",
  },

  {
    nombre: "Página o Grupo de Facebook \"Peligrosa.mx.1370am TLX 1600amPue cd.serdan\"",
    sexo: "N/A",
    ambito: "Municipal",
    entidad: "Tlaxcala",
    municipio: "Huamantla",
    relacion: "N/A",
    incidencia: "N/A",
    expediente: "TET-PES-002/2025",
    organo: "TET",
    fecha: "01 de Septiembre de 2026",
    conducta: "Las publicaciones denunciadas, actualizan la infracción de VPG, al contener manifestaciones dirigidas a sexualizar y desacreditar a la denunciante con estereotipos de género.",
    sancion: "",
    permanencia: "INDETERMINADO",
    analizo: "N/A",
    cumple: "N/A",
    calidad: "N/A",
    documento: "https://sistemas-tet.org.mx/sistemas/archivos/resoluciones/20260923195741_RESOLUCION_TET-PES-002-2025.pdf",
  },


  {
    nombre: "Página o Grupo de Facebook \"MERCADO LIBRE LA MAGDALENA TLALTELULCO\"",
    sexo: "N/A",
    ambito: "Municipal",
    entidad: "Tlaxcala",
    municipio: "Huamantla",
    relacion: "N/A",
    incidencia: "N/A",
    expediente: "TET-PES-002/2025",
    organo: "TET",
    fecha: "01 de Septiembre de 2026",
    conducta: "Las publicaciones denunciadas, actualizan la infracción de VPG, al contener manifestaciones dirigidas a sexualizar y desacreditar a la denunciante con estereotipos de género.",
    sancion: "",
    permanencia: "INDETERMINADO",
    analizo: "N/A",
    cumple: "N/A",
    calidad: "N/A",
    documento: "https://sistemas-tet.org.mx/sistemas/archivos/resoluciones/20260923195741_RESOLUCION_TET-PES-002-2025.pdf",
  },

];

// Datos para las infografías
export const dataInfografias = [
  /* {
    id: 1,
    link: "https://itetlax.org.mx/assets/img/reps/info1.png",
    alt: "Infografía 1",
  },
  {
    id: 2,
    link: "https://itetlax.org.mx/assets/img/reps/info2.png",
    alt: "Infografía 2",
  }, */
];
